import styled from 'styled-components';
import { themeGet } from '@magalu/stereo-ui-styles';
import Text from '../../atoms/Text';
import Box from '../../atoms/Box';
export const Row = styled(Box)`
  padding-bottom: ${themeGet('space.2')}px;
`;
export const Tiny = styled(Text)`
  text-decoration: underline;
  cursor: pointer;
`;